<template>
	<v-card :id="'course' + data.id" outlined class="mx-auto mt-2" max-width="95%">
		<v-card-text>
			<v-list-item three-line class="pa-0">
				<v-list-item-avatar size="40">
					<v-img :src="require('../../assets/' + getImg(data.curso_tipo))" width="40" height="40"></v-img>
				</v-list-item-avatar>
				<v-list-item-content>
					<v-subheader class="icoev-subheader-course">{{ data.curso_tipo }}</v-subheader>
					<div class="icoev-date-text">{{ data.fechades }}</div>
					<div class="icoev-date-text">{{ data.fechahor }}</div>
					<!-- <div class="icoev-date-text">{{ data.fecha + " - " + data.fechahor }}</div> -->
					<v-list-item-title class="primary--text mb-1 icoev-item-title">
						{{ data.curso_desc }}
					</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
		</v-card-text>
		<v-divider/>
		<v-card-actions>
			<v-btn text color="primary" @click="openUrl('Inscripción', data.link_curso)">Inscripción</v-btn>
			<v-spacer></v-spacer>
			<v-btn text color="primary" @click="openUrl('Programa', data.link_progr)">Ver programa</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import BaseModule from "./BaseModule";
import cordova from "../../api/cordova";

export default {
	name: 'CourseItem',
	mixins: [ BaseModule ],
	props: [ 'data' ],
	data() {
		return {
			getImg(type) {
				var img;

				switch (type) {
					case 'Curso ICOEV':
					case 'Cursos ICOEV Gratuitos':
					case 'Cursos Odontólogos Colegiados':
						img = 'cursos-icoev.png'; break;
					case 'Cursos SEPA': 
						img = 'cursos-sepa.png'; break;
					case 'Cursos Consejo': 
						img = 'cursos-consejo.png'; break;
					default:
						img = 'cursos-icoev.png'; break;
				}
				
        return img;
      },
			openUrl(title, url) {
				if (url.endsWith('.pdf') && this.$store.state.icoev.device.platform == 'android') {
					cordova.openUrl(encodeURI(url));
					return;
				}

				this.$emit('open-external-content', title, url);
			},
		}
	},
}
</script>